module.exports = __webpack_public_path__ + "static/media/check-green-circle.53077fa3.svg";